import maize from './maize.json';
import main from './main.json';
import grapevine from './grapevine.json';
import oryza from './oryza.json';
import sorghum from './sorghum.json';
import yeast from './yeast.json';

export default [main,maize,grapevine,oryza,sorghum,yeast];

